export default "__VITE_ASSET__DRFnx1f$__"